import TeamDetailBadge from '@/screens/TeamDetailBadge';

export default function PrivateTabsEventTeamTeamIdBadgeRoute() {
  return <TeamDetailBadge badgePathname="/event/badge/[badgeId]" />;
}
